<script>
  import Filter from "../../../Filter/Filter.svelte";
  import { onMount } from "svelte";
  import {External, M} from "../../../external";
  import {ignore} from "../../../Common/tools";

  export let data;
  export let valid;
  export let onChange = ignore;

  let filters = [];
  filters[0] = [];
  let filterInstance;

  let counter = 0;
  if (data && data.settings) {
    data.settings.forEach((setting) => {
      let sett = JSON.parse(setting.value);
      sett.key = parseInt(setting.key);
      filters[0].push(sett);
    });
  }
  valid = filters[0].length > 0;

  const onFilterChange = (notify) => {
    if (filters) {
      data.settings = [];
      counter = 0;
      filters[0].forEach((filter) => {
        filter.key = counter;
        data.settings.push({
          key: filter.key + "",
          value: JSON.stringify({
            func: filter.func,
            type: filter.type,
            id: filter.id,
            value: filter.value
          })
        });
        counter++;
      });
      data.name = filters[0].map((filter) => filter.value).join(", ");
      valid = filters[0].length > 0;
      if (notify !== false && valid) {
        onChange();
      }
    }
  };

  onFilterChange(false);

  onMount(function () {
    filterInstance.onFilterChanged();
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.TRIGGER_PROPERTY_CHANGE}</h4>
  <div class="multiple-items-picker mt-25 mb-5">
    <div class="groups category-groups mb-15" style="max-width:1200px;">
      <Filter enableOR={false} addNonPropertyFilters={false} enableSaveSegment={false} enableHide={false} bind:this={filterInstance} bind:filters onChange={onFilterChange} />
    </div>
  </div>
  <div class="col20 f-left gray-section product-select-wrapper mb-5 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
